import { AlLocatorService, AIMSClient } from "@al/core";
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

declare var auth0: any;

@Component({
  selector: 'password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: [ './password-reset.component.scss' ]
})

export class PasswordResetComponent implements OnInit {

    public emailAddress:string;
    public token:string;
    public newPassword:string;
    public confirmPassword:string;
    public state:string = "change";
    public errorMessage:string = "";
    public returnUrl:string;

    public showNewPassword: boolean = false;
    public showConfirmNewPassword: boolean = false;

    public webAuth:any;

    constructor ( public router:Router,
                 private activatedRoute: ActivatedRoute
    ){}

    ngOnInit() {
        // Route params
        this.activatedRoute.params.subscribe((params: Params) => {
            this.token = params['token'];
            if (!this.token) {
                this.state = "error";
                this.errorMessage = "Invalid parameters";
            }
        });
        // Query string params
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.emailAddress = params['email'];
            this.returnUrl    = params['return_to'];
            if (!this.emailAddress) {
                this.state = "error";
                this.errorMessage = "Invalid parameters";
            }
        });
    }

    /** When user click on the change password button */
    onSubmit = async () => {
        this.state = "loading";
        if (!this.token) {
            this.manageErrors("Invalid token");
            this.state = "error";
            return
        }
        if (!this.newPassword) {
            this.manageErrors("Invalid password");
            this.state = "error";
            return
        }
        try {
            await AIMSClient.resetWithToken(this.token, this.newPassword);
            this.state = "done";
            this.closeMessageError();
        } catch (error) {
            this.state = "change";
            this.manageErrors(error.data.error);
        }
    }

    /** When user click on the return to login button */
    onReturnToLogin = () => {
        window.location.href = this.returnUrl ? this.returnUrl : AlLocatorService.resolveURL( "cd17:accounts", "" );
    }

    /** Toggle show new password */
    toggleShowNewPassword = () => {
        this.showNewPassword = !this.showNewPassword
    }

    /** Toggle show confirm new password */
    toggleShowConfirmNewPassword = () => {
        this.showConfirmNewPassword = !this.showConfirmNewPassword
    }

    /** Manage the errors */
    manageErrors = ( error:any ) => {
        let message = "An internal error occurred while saving your information. Please try again.";
        if (error === 'weak_password') {
            message = "Cannot perform request due to weak password.";
        }else if (error === 'password_reuse_prevented') {
            message = "Cannot update user information, because the password was already used.";
        }else if (error === 'Not Found') {
            message = "The link you used was not found, or has expired. Please submit your request again to receive another link.";
        }else if (error === 'unauthorized') {
            message = "Alert Logic could not authenticate your credentials.";
        }

        this.showErrorMsg(message);
    }

    /** Show an error message */
    showErrorMsg = ( msg:any ) => {
        // TODO: replace this for the notification panel
        this.errorMessage = msg;
    }

    /** Close error message */
    closeMessageError = () => {
        this.errorMessage = "";
    }
}
